import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UnitFormLayer from "../components/UnitFormLayer";

const UnitFormPage = () => {
    return (
        <MasterLayout>
            <UnitFormLayer />
        </MasterLayout>
    );
};

export default UnitFormPage;
